import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

export default class pickupdashboardservice {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async _post(endpointName, method, param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: endpointName });
    let itemArray = [];
    await myApi.endpoints[endpointName]
      .getAllPost(param)
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err);
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = method(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  getPickupAttention(param) {
    return this._post(this.endpoint.GET_PICKUP_ATTENTION, this.getPickupAttention.bind(this), param);
  }
  getPickupCancellations(param) {
    return this._post(this.endpoint.GET_PICKUP_CANCELLATIONS, this.getPickupCancellations.bind(this), param);
  }
  getPickupByStore(param) {
    return this._post(this.endpoint.GET_PICKUP_BY_STORE, this.getPickupByStore.bind(this), param);
  }
  getPickupAgentLeaderboard(param) {
    return this._post(this.endpoint.GET_PICKUP_AGENT_LEADERBOARD, this.getPickupAgentLeaderboard.bind(this), param);
  }
  getPickupActionList(param) {
    return this._post(this.endpoint.GET_PICKUP_ACTION_LIST, this.getPickupActionList.bind(this), param);
  }
}
